// Copyright (c) StrangeBee 2024

import { Form } from 'antd';
import React, { ReactElement } from 'react';
import { WidgetDonutOutput } from 'thehive-sdk';
import { useDashboard } from '@Hooks/useDashboard';
import WidgetDrawer from '@Organisms/Dashboard/WidgetManage/WidgetDrawer';
import { DonutForm, DonutValues } from '@Organisms/Dashboard/WidgetManage/Donut/DonutForm';
import { getNewDonutWidget } from './NewDonutDrawer';

interface DonutDrawerProps {
    data: WidgetDonutOutput;
}

const DonutDrawer = ({ data }: DonutDrawerProps): ReactElement => {
    const [form] = Form.useForm();
    const { editWidget } = useDashboard();

    const onFinish = (donut: DonutValues): void => {
        const widgetId = data.id;
        const widgetDonut: WidgetDonutOutput = {
            ...getNewDonutWidget(donut),
            id: widgetId,
        };

        editWidget(widgetDonut, widgetId);
        form.resetFields();
    };

    return (
        <WidgetDrawer form={form} widgetType="donut">
            {(toggleDrawer, { setFieldsTouched }) => (
                <DonutForm
                    form={form}
                    onFinish={(values) => {
                        onFinish(values);
                        toggleDrawer();
                    }}
                    onCancel={() => {
                        setFieldsTouched(false);
                        form.resetFields();
                        toggleDrawer();
                    }}
                    onChange={() => {
                        setFieldsTouched(true);
                    }}
                    defaultValues={data}
                />
            )}
        </WidgetDrawer>
    );
};

export default DonutDrawer;
